import {Component, Input} from "@angular/core";
import {RuleConfig} from "../../../../../model/channels.model";

@Component({
  selector: "admin-channels-rule-header",
  templateUrl: "./rule-header.component.html",
  styleUrls: ["./rule-header.component.css"]
})
export class RuleHeaderComponent {

  @Input() rule?: RuleConfig;

}
